import React from 'react';
import { CalendarIcon, ChevronRightIcon, FileTextIcon } from 'lucide-react';
import { CreditReport } from '../types/credit';
type ReportPickerProps = {
  reports: CreditReport[];
  onSelect: (report: CreditReport) => void;
};
export function ReportPicker({
  reports,
  onSelect
}: ReportPickerProps) {
  return <section className="mx-auto w-full max-w-6xl px-6 pb-12 pt-6" aria-labelledby="pick-heading" data-id="element-85" data-mp="21a3syw11r28a">
      <h2 id="pick-heading" className="text-xl font-semibold text-ink-900" data-id="element-86" data-mp="2xyb58z44g49o">
        Choose a credit report
      </h2>
      <p className="mt-1 text-sm text-ink-500" data-id="element-87" data-mp="2tysugw60l9kk">
        Pick which pulled report you want to work from. The most recent pull is
        listed first.
      </p>

      <ul className="mt-6 space-y-3" data-id="element-88" data-mp="2k8zihu1ymsfs">
        {reports.map((report, index) => <li key={report.id} data-id="element-89" data-mp="3hnbuypitoi23" data-mpi={index}>
            <button type="button" onClick={() => onSelect(report)} className="group flex w-full flex-col gap-5 rounded-lg border border-ink-100 bg-white p-5 text-left shadow-sm transition-colors hover:border-brand-200 hover:bg-brand-50/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-90" data-mp="3hodgjnxgsmy2">
              <div className="flex min-w-0 items-center gap-4" data-id="element-91" data-mp="3pzdl26m6shfl">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-ink-50 text-ink-700 ring-1 ring-inset ring-ink-100 transition-colors group-hover:bg-white" aria-hidden="true" data-id="element-92" data-mp="3u18mdb44autd">
                  <FileTextIcon className="h-5 w-5" data-id="element-93" data-mp="372u7940fu5cp" />
                </span>
                <div className="min-w-0" data-id="element-94" data-mp="3b3xonuy4w9g1">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-95" data-mp="3b4yyxx7bsrwp">
                    <span className="text-base font-semibold leading-tight text-ink-900" data-id="element-96" data-mp="15b8uj1h7ficb">
                      {report.bureauLabel} · {report.provider}
                    </span>
                    {index === 0 && <span className="rounded-full bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-800 ring-1 ring-inset ring-green-200" data-id="element-97" data-mp="2i9rd8c92i2j9">
                        Most recent
                      </span>}
                  </div>
                  <p className="mt-1 flex flex-wrap items-center gap-x-2 text-sm leading-tight text-ink-500" data-id="element-98" data-mp="29anu589whn4r">
                    <CalendarIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-99" data-mp="30zzaweu000s2" />
                    Pulled {report.pulledOn} by {report.pulledBy}
                    <span aria-hidden="true" data-id="element-100" data-mp="2s75idfpjj4w9">·</span>
                    {report.liabilities.length} liabilities
                  </p>
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-6 sm:pl-4" data-id="element-101" data-mp="3knzrr1f2h9ih">
                <div className="flex w-[168px] justify-end gap-2" data-id="element-102" data-mp="3kpax35o5upbp">
                  {report.scores.map(score => <div key={score.bureau} className="w-[52px] rounded-md bg-ink-50 py-1.5 text-center" data-id="element-103" data-mp="3fvezw5fq16hl">
                      <div className="text-[11px] font-medium uppercase leading-none tracking-wide text-ink-500" data-id="element-104" data-mp="3s80urzxm0vv6">
                        {score.bureau}
                      </div>
                      <div className="mt-1 text-base font-semibold leading-none tabular-nums text-ink-900" data-id="element-105" data-mp="53kriybbnqcv">
                        {score.score}
                      </div>
                    </div>)}
                </div>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-ink-300 transition-colors group-hover:text-brand-500" aria-hidden="true" data-id="element-106" data-mp="eymf3ppy8kdc" />
              </div>
            </button>
          </li>)}
      </ul>
    </section>;
}